import React, { Fragment } from "react";
import { getFieldPath } from "utils/form";
import Toggle from "../common/Toggle";
import PatternSelect from "../common/PatternSelect";
import Request from "../common/Request";

const ValidationsFields = ({ name }) => (
  <Fragment>
    <Toggle
      name={getFieldPath(name, "validation.required")}
      description="Must have a value to complete checkout."
    />
    <div className="pt3 mt3 bt hairline-1">
      <PatternSelect name={getFieldPath(name, "validation.pattern")} />
    </div>
    <div className="pt3 mt3 bt hairline-1">
      <Request name={name} />
    </div>
  </Fragment>
);

export default ValidationsFields;
